// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
import { BestLayoutProposalFragmentDoc } from './BestLayout/BestLayout.generated-types';
import { DocumentsProposalFragmentDoc } from './Documents/Documents.generated-types';
import { GetAddressProposalFragmentDoc } from '../../../Graphql-Utilities/getAddress/getAddress.generated-types';
export type ProposalInfoCardProposalFragment = { __typename?: 'Proposal', message?: string | null, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, description?: string | null, tour3dUrl?: string | null, hostContact: { __typename?: 'HostContact', avatar?: { __typename?: 'Avatar', normal?: string | null, small?: string | null, thumb?: string | null } | null }, spaceFeatures?: Array<{ __typename?: 'SelfServeSpaceFeature', name?: string | null }> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, latitude?: number | null, longitude?: number | null, addressLine1?: string | null, city?: string | null, postalCode?: string | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null, distanceKm?: number | null } | null } | null, spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null }, documents?: Array<{ __typename?: 'ProposalDocument', filename: string, URL: string, s3Key: string }> | null };

export const ProposalInfoCardProposalFragmentDoc = gql`
    fragment ProposalInfoCardProposal on Proposal {
  message
  space {
    spaceName
    description
    hostContact {
      avatar {
        normal
        small
        thumb
      }
    }
    spaceFeatures {
      name
    }
    tour3dUrl
    venue {
      name
      nearestTransit {
        station
        distanceKm
      }
      latitude
      longitude
    }
  }
  ...BestLayoutProposal
  ...DocumentsProposal
  ...GetAddressProposal
}
    ${BestLayoutProposalFragmentDoc}
${DocumentsProposalFragmentDoc}
${GetAddressProposalFragmentDoc}`;